import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import { FullSizeCenteredFlexBox } from '../../../Components/FlexBox';
import ActivityOutcomeItem from './ActivityOutcomeItem';
import { ACTIVITY_TYPES_COLORS } from '../../../Utils/constants/activityTypes';
import ActivityOutcomeDialog from './ActivityOutcomeDialog';
import keysToLowerCase from '../../../Helpers/keysToLowerCase';
import PhoneForwardedOutlinedIcon from '@mui/icons-material/PhoneForwardedOutlined';
import PhoneMissedOutlinedIcon from '@mui/icons-material/PhoneMissedOutlined';
import parseValuesToBoolean from '../../../Helpers/parseValuesToBoolean';

const ActivityTypeAccordion = function ActivityTypeAccordion({
  id,
  name,
  Icon,
  activityOutcomes,
  addToActivityOutcomes,
  editActivityOutcome,
  onChangeIsActive,
  activityTypes,
}) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  const handleOpenDialog = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleOpenEditDialog = (activityOutcomeId) => {
    const activityOutcomeToEdit = activityOutcomes.find(
      ({ id }) => id === activityOutcomeId
    );

    if (!activityOutcomeToEdit) return;
    setOpen(activityOutcomeToEdit);
  };

  const handleSubmit = (data) => {
    addToActivityOutcomes({ ...data, activityTypeId: id }, handleCloseDialog);
  };

  const handleSubmitEdit = (data) => {
    editActivityOutcome({ ...data, activityTypeId: id }, handleCloseDialog);
  };

  return (
    <>
      <ActivityOutcomeDialog
        open={Boolean(open)}
        onClose={handleCloseDialog}
        activityType={name}
        onSubmit={open === true ? handleSubmit : handleSubmitEdit}
        defaultData={open === true ? undefined : open}
        activityTypes={activityTypes}
      />
      <Accordion id={`causal-entry-accordion-${id}`}>
        <AccordionSummary id={`${id}-summary`} expandIcon={<ExpandMoreIcon />}>
          <FullSizeCenteredFlexBox gap="16px" padding="0px 16px 0px 0px">
            {Icon && <Icon sx={{ color: ACTIVITY_TYPES_COLORS[name] }} />}
            <Typography variant="h6">{intl.messages[name]}</Typography>
            <Button
              id={`add-causal-button-${id}`}
              variant="outlined"
              size="large"
              sx={{ ml: 'auto' }}
              startIcon={<AddCircleRoundedIcon />}
              onClick={handleOpenDialog}
            >
              {intl.messages.ADD_NEW}
            </Button>
          </FullSizeCenteredFlexBox>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={1} sx={{ paddingLeft: '36px' }}>
            {activityOutcomes.map(
              ({
                id: activityOutcomeId,
                name: activityOutcomeName,
                isActive,
                campaignAdvancement,
                extensionData,
              }) => (
                <ActivityOutcomeItem
                  key={activityOutcomeId}
                  id={activityOutcomeId}
                  icon={
                    parseValuesToBoolean(
                      keysToLowerCase(JSON.parse(extensionData))
                    )?.answered !== undefined ? (
                      parseValuesToBoolean(
                        keysToLowerCase(JSON.parse(extensionData))
                      )?.answered ? (
                        <PhoneForwardedOutlinedIcon color="success" />
                      ) : (
                        <PhoneMissedOutlinedIcon color="error" />
                      )
                    ) : undefined
                  }
                  name={activityOutcomeName}
                  campaignAdvancement={campaignAdvancement}
                  extensionData={JSON.parse(extensionData || '{}')}
                  isActive={isActive}
                  activityTypeName={name}
                  onChangeIsActive={onChangeIsActive}
                  onEdit={handleOpenEditDialog}
                  activityTypes={activityTypes}
                />
              )
            )}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default ActivityTypeAccordion;
